module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter5"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006toc#ch05"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" Five")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pregnancy test couldn’t be used until the next morning, so Tory hid it under her pillow and decided not to tell Barry until she was sure. But as Tory cooked supper and Barry helped Brittany with her homework, Spencer broadcast her secret. “Mommy’s been perjecting all over the place,” he said. “At Joseph’s house, at Britty’s school…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perjecting?” Barry asked, mildly amused. “What do you mean, perjecting?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know. Gettin’ sick. Perjectine barfing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Projectile?” Barry asked, shooting Tory a look. “Tory, are you okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She drew in a deep breath and looked wearily at her son. “Spencer, where do you get these words? He must have used six synonyms for vomiting today.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He gets it from Nickelodeon,” Brittany said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barry nodded agreement. “It’s one of their favorite subjects.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I told you we needed to get rid of television.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }), _vm._v("“So is it true?” Barry asked. “Have you been sick?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shrugged. “Must be a stomach virus. I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you looked a little pale.” He got up and came to the stove. “Here, let me finish cooking. You don’t need to be standing over this if you’re sick.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I’m probably spreading germs, anyway,” she said. She couldn’t believe she was rooting for germs, when she spent so much time blasting Lysol on anything that could breed them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He kissed her cheek. “Go sit down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m fine,” she said as she headed out of the room. “Really. By tomorrow, I’ll be as good as new.” But even as she said the words, she knew it wasn’t true.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later that night, Barry read the kids a chapter of "), _c('i', [_vm._v("Charlotte’s Web")]), _vm._v(", while Tory cleaned the kitchen until it shined. She worried as she worked. When she was finished, she went to tuck them in, and wondered what it would be like to have a third little one demanding a glass of water, another kiss good night, a better hug, and a night-light that didn’t cast shadows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she finally made it back to her bedroom, Barry was changing into a pair of sweatpants and a T-shirt. “How do you feel?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, right now,” she said. “It just hits me, all of a sudden.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long have you been doing this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just today. I’ve been kind of queasy for a few days,” she said, downplaying it as much as she could. “It always passed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She tried to keep her eyes averted, but he grabbed her hand and pulled her to face him. Sliding his arms around her, he looked down at her with amused eyes. “You’re not pregnant, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She couldn’t help grinning back. If she said yes, Barry wouldn’t see it as a tragedy. “The thought has occurred to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He kept grinning down at her, as if trying to decide if she was serious. “Are you late?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe a little.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His grin faded. “How late? One week? Two?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She swallowed hard. “About…urn…nine weeks, as far as I can tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }), _vm._v("He dropped his arms and stepped back. “Nine weeks? Tory!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know,” she said, clutching her head. “It’s so stupid not to realize I’d already missed one. My last period should have been around the time Joseph was so sick. I must have been so distracted that I didn’t realize I was late. And I’ve been really busy with the kids and the writing. I just didn’t realize—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay.” He grabbed his keys off of the dresser. “That’s it. I’m going to buy a pregnancy test. How late is Walmart open?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No need, Barry,” she said, stopping him. “I beat you to it.” She went around the bed and got the box out from under her pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The reality of it seemed to knock the wind out of him. He sank down on the bed, looking a little shell-shocked. “You really think you could be, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if I am?” she asked him. “This will be the first one we didn’t plan for. Can we still be happy about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He seemed to think that over, and slowly a smile returned to his face. “Of course we can. I’m just so…stunned. You never mentioned that you were late, or that you felt bad…But yes, we can be happy about it. "), _c('i', [_vm._v("Of course")]), _vm._v(" we can be happy about it.” He laughed then, a sound that filled her with relief. He reached out to pull her onto his lap. “We can be very happy about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I’ll turn into a cow again, and I’ll waddle like a duck…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stroked her hair behind her ear. “Tory, both times, you were the best-looking pregnant woman I’d ever seen. You "), _c('i', [_vm._v("never")]), _vm._v(" waddled like a duck. You gained all of twenty pounds on each baby, and lost it in the first six months. The doctor was yelling at "), _c('i', [_vm._v("me")]), _vm._v(" for not making you eat more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would have gained more if I hadn’t had such bad morning sickness.” She sighed. “Barry, I don’t know if I’m ready to go through all that again. And my writing is going so well. How will I ever write if there’s a new baby to take care of?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can make time if you really want to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the thing,” she said. “If I have a new baby, I won’t really "), _c('i', [_vm._v("want")]), _vm._v(" to write. It takes so much energy to take care of a baby.” Her face flushed pink at the thought, and she gave in to "), _c('a', {
    attrs: {
      "id": "page38"
    }
  }), _vm._v("a smile. “A baby…” she said with awe. “Barry, another little baby.” Her smile faded again, and she closed her eyes. “Oh, no. A baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tory, stop worrying. It’s out of your control. Either you are, or you aren’t. If we have another baby, it’s because God wants us to. End of story.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She couldn’t help laughing softly. “You’re right. And if I am, I’m sure I’ll be happy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He chuckled against her ear. “Happy? You’ll be thrilled. You’ll probably cry if the test is negative.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She knew that was true. There was some part of her that hoped it was positive. “What about you? How will you feel?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll feel like the luckiest guy in the world,” he said. “A new baby. It’s about the best thing I can think of.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even if we don’t have an extra bedroom? Even if we don’t have time?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll build on. And since when did anyone really have time for a baby? Once it comes, you laugh that you ever thought it was something you had to fit in. It just takes over.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But Spencer and Britty have already taken over.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So we’ll have three little tyrants, instead of two. We’ll love it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still grinning, she opened the box of the pregnancy test and read the instructions. “It says that we can do the test the first thing in the morning. The results will be ready in ten minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So just get some rest and don’t worry about it until morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Tory knew that she would worry all night. This wasn’t the kind of thing she could shift to the back of her mind. If that test was positive, their lives would never be the same.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35b28dd7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/011-chapter5.vue
// module id = 81
// module chunks = 0